import clsx from 'clsx';

export default clsx;
